<template>
  <div class="language-selector">
    <h3 class="language-selector__title">{{ t("output_language") }}</h3>
    <div class="language-selector__container">
      <div
        class="language-selector__indicator"
        :style="{ transform: `translateX(${indicatorPosition}%)` }"
      ></div>
      <button
        v-for="lang in languages"
        :key="lang.value"
        class="language-selector__option"
        :class="{
          'language-selector__option--selected':
            selectedLanguage === lang.value,
        }"
        @click="selectLanguage(lang.value)"
      >
        {{ lang.label }}
      </button>
    </div>
  </div>
</template>

<script>
import { computed } from "vue";
import { Languages } from "../../types";
import { useI18n } from "../../i18n";

export default {
  name: "LanguageSelector",
  props: {
    selectedLanguage: {
      type: String,
      default: Languages.AUTO,
    },
  },
  emits: ["select"],
  setup(props, { emit }) {
    const { t } = useI18n();

    const languages = computed(() => [
      { value: Languages.AUTO, label: t("auto_detect") },
      { value: Languages.ARABIC, label: t("language_ar") },
      { value: Languages.ENGLISH, label: t("language_en") },
    ]);

    const indicatorPosition = computed(() => {
      const index = languages.value.findIndex(
        (l) => l.value === props.selectedLanguage
      );
      return index * 100;
    });

    const selectLanguage = (language) => {
      emit("select", language);
    };

    return {
      t,
      languages,
      indicatorPosition,
      selectLanguage,
    };
  },
};
</script>

<style scoped>
.language-selector {
  padding: 0 12px;
}

.language-selector__title {
  font-size: 18px;
  font-weight: 600;
  color: #1f2937;
  margin: 0 0 8px 0;
}

.language-selector__container {
  position: relative;
  display: flex;
  height: 48px;
  background: #f3f4f6;
  border-radius: 16px;
  padding: 6px;
}

.language-selector__indicator {
  position: absolute;
  top: 6px;
  bottom: 6px;
  left: 6px;
  width: calc(33.333% - 4px);
  background: var(--mia-primary);
  border-radius: 12px;
  transition: transform 0.2s ease-in-out;
}

.language-selector__option {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 500;
  color: #6b7280;
  background: transparent;
  border: none;
  cursor: pointer;
  z-index: 1;
  transition: color 0.2s ease;
}

.language-selector__option--selected {
  color: white;
  font-weight: 600;
}
</style>
